import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useEntityPresentation } from '@backstage/plugin-catalog-react';
import { useExtendedTechDocsMetadata } from '../hooks/useExtendedTechDocsMetadata';

export const TechDocsReaderPageTabTitle = (props: {
  baseTabTitleItems?: string[];
}) => {
  const { baseTabTitleItems = [] } = props;
  const { '*': path = '' } = useParams();
  const { entityRef } = useTechDocsReaderPage();
  const { primaryTitle: entityDisplayName } = useEntityPresentation(entityRef);
  const { parentTitles, title: pageTitle } = useExtendedTechDocsMetadata(
    entityRef,
    path,
  );
  const tabTitleItems = [
    ...baseTabTitleItems,
    entityDisplayName,
    ...parentTitles,
    ...(pageTitle ? [pageTitle] : []),
  ].filter(Boolean) as string[];
  return tabTitleItems.length ? (
    <Helmet titleTemplate="%s">
      <title>{tabTitleItems.join(' | ')}</title>
    </Helmet>
  ) : null;
};
